/* Use the product cards' visible content edges for the lower home sections. */
(() => {
  if (!document.body.classList.contains('template-index')) return;
  let pending = false;
  function align() {
    pending = false;
    const section = document.querySelector('.sections-product-block');
    const container = section?.querySelector('.product-block > .container-1770') || section?.querySelector('.container-1770');
    const card = section?.querySelector('.product-item .card');
    if (!container || !card) return;
    const box = container.getBoundingClientRect();
    const first = card.getBoundingClientRect();
    const inset = Math.max(0, first.left - box.left);
    const width = Math.min(box.width, box.width - inset * 2);
    if (width <= 0) return;
    document.documentElement.style.setProperty('--olitans-home-content-width', `${width}px`);
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(align);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  function start() {
    const section = document.querySelector('.sections-product-block');
    if (!section) return;
    new ResizeObserver(schedule).observe(section);
    new MutationObserver(schedule).observe(section, {childList:true, subtree:true});
    window.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  }
})();
